import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AccessibleClickDirective } from '../../directives/accessible-click.directive';
import { FocusService } from '@core';

@Component({
  selector: 'lib-footer-nav-link',
  imports: [MatIconModule, AccessibleClickDirective],
  templateUrl: './footer-nav-link.component.html',
  styleUrl: './footer-nav-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterNavLinkComponent {
  label = input.required<string>();
  ariaLabel = input<string>();
  path = input<string>();
  href = input<string>();

  readonly router = inject(Router);
  readonly focusService = inject(FocusService);

  navigate() {
    if (this.href()) {
      window.open(this.href(), '_blank');
      return;
    }
    if (this.path()) {
      this.router.navigate([this.path()]).then(() => {
        this.focusService.focusHeaderAction();
      });
    }
  }
}
